import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ExpandableText from '@/components/widgets/ExpandableText.vue';
import { useField } from 'vee-validate';
import { toRef } from 'vue';

type Props = {
    rules: string | Record<string, unknown>;
    required: boolean;
    name: string;
    label: string;
    detailsText?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxField',
  props: {
    rules: {},
    required: { type: Boolean },
    name: {},
    label: {},
    detailsText: {}
  },
  setup(__props: any) {

const props = __props;

const rulesRef = toRef(props, 'rules');

const { value, errorMessage } = useField(() => props.name, rulesRef, {
    syncVModel: true
});

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(_component_v_checkbox, _mergeProps(_ctx.$attrs, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
    color: "szViolet",
    "false-value": null,
    "true-value": true,
    "error-messages": _unref(errorMessage),
    class: "mt-0 pa-0 custom-checkbox-field"
  }), {
    label: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(ExpandableText, {
          class: _normalizeClass({ 'prepend-required': _ctx.required }),
          text: _ctx.label,
          "additional-text": _ctx.detailsText
        }, null, 8, ["class", "text", "additional-text"])
      ])
    ]),
    _: 1
  }, 16, ["modelValue", "error-messages"]))
}
}

})